import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@Components/common';
import { useRouter } from '@Helpers/useRouter';
import { QueryParams, Routes, RoutingPaths } from '@App/paths';
import styles from './LoginButtons.module.scss';

export const LoginButtons = () => {
  const { t } = useTranslation('landingPage');
  const { push, params } = useRouter();

  // Extract applyFundId to pass to sign-in if present
  const applyFundId = params[QueryParams.APPLY_FUND_ID]
    ? parseInt(params[QueryParams.APPLY_FUND_ID] as string)
    : undefined;
  const signInUrl = applyFundId
    ? Routes.SIGN_IN_WITH_APPLY_FUND(applyFundId)
    : RoutingPaths.SIGN_IN;

  return (
    <Button
      onClick={() => {
        push(signInUrl);
      }}
      buttonType="text"
      className={styles.loginButton}
      size="small"
    >
      {t('sign_in')}
    </Button>
  );
};
